import React, { useState } from "react";
import pipaanlogo from "../assets/pipaanlogo.svg";
import closecircle from "../assets/images/icons/close-circle.png";
import businessbadge from "../assets/images/icons/Business-badge.svg";
import Individualbadge from "../assets/images/icons/Individual-badge.svg";
import influencerbadge from "../assets/images/icons/influencer-badge.svg";
import visacardImg from "../assets/images/icons/visa.svg";
import mastercardImg from "../assets/images/icons/mastercard.svg";
import verifyarrow from "../assets/images/icons/verify-arrow.svg";
import paymentsuccess from "../assets/images/icons/Payment-success.svg";
import paymentfailed from "../assets/images/icons/retry-payment.svg";
import Retryicon from "../assets/images/icons/refresh-right-square.svg";
import { IoCloseCircle, IoCheckmarkCircle } from "react-icons/io5";
import uploadIcon from "../assets/images/icons/document-upload.svg";

const Renewverifyaccount = ({
    isOpen,
    userData,
    profileimg,
    getverified,
}) => {
    // 1. ALL HOOKS AT THE TOP
    const [isFormView, setIsFormView] = useState(false);
    const [selectedCard, setSelectedCard] = useState("mastercard");
    const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
    const [paymentError, setPaymentError] = useState(false);
    const [files, setFiles] = useState({
        companyCert: null,
        licenseCert: null,
        moa: null,
        boardResolution: null,
    });

    // 2. CONDITIONAL RETURN AFTER HOOKS
    if (!isOpen) return null;

    // Logic Helpers
    const isBusinessAccount = userData?.account_type === 'business';
    const isInfluencerAccount = userData?.account_type === 'influencer';
    const hasMinFollowers = (userData?.followersCount || 0) >= 1;

    const cards = [
        { id: 'mastercard', name: 'Mastercard', last4: '5432', expiry: '12/20', img: mastercardImg },
        { id: 'visa', name: 'Visa', last4: '4291', expiry: '12/20', img: visacardImg },
    ];

    const handleClose = () => {
        getverified(false);
        setIsFormView(false);
        setIsPaymentSuccess(false);
    };

    return (
        <div>
            <div className="get-verified popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                <div className="border-popup bg-white rounded-lg relative">

                    {/* HEADER */}
                    <div className="flex justify-between">
                        <div className="logo-popup flex items-center justify-center space-x-2">
                            <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
                        </div>
                        <button onClick={handleClose}>
                            <img src={closecircle} alt="close" className="w-8 h-8" />
                        </button>
                    </div>


                    {/* SUCCESS CONTENT REPLACES EVERYTHING BELOW HEADER IF SUCCESSFUL */}
                    {isPaymentSuccess ? (
                        <div>
                            <h2 className="text-[#000000] text-[32px] font-semibold">
                                {isFormView ? "Get Verified on Pipaan" : "Get Verified on Pipaan"}
                            </h2>

                            <hr className="bg-[#D9D9D9]" />

                            <div className="border-t-[#D9D9D9] border-t-2 flex flex-col items-center justify-center py-12 text-center animate-fadeIn px-10">
                                <div className="w-full">
                                    {/* PROFILE */}
                                    <div className=" flex items-center w-full justify-between">
                                        <div className="flex items-start relative left-5">
                                            <div className="profile-dashboard profile-page-dashboard-modal overflow-hidden relative">
                                                <img
                                                    src={userData?.profile_picture_url || profileimg}
                                                    alt="Profile"
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>

                                            <div className="feed-title pl-4 flex flex-col">
                                                <p className="font-semibold text-[20px]">
                                                    {userData?.first_name} {userData?.last_name || "N/A"}
                                                </p>
                                                <p className="text-sm text-[#747474]">
                                                    @{userData?.username || "N/A"}
                                                </p>
                                                <p className="text-sm text-[#095228] font-semibold">
                                                    {userData?.followersCount || 0} Followers
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <img
                                                src={
                                                    isBusinessAccount ? businessbadge :
                                                        isInfluencerAccount ? influencerbadge :
                                                            Individualbadge
                                                }
                                                className="w-8 h-8"
                                                alt="badge"
                                            />
                                            <div className="flex flex-col">
                                                <h2 className="text-md font-semibold">
                                                    {isFormView
                                                        ? isBusinessAccount ? "Business Verification"
                                                            : isInfluencerAccount ? "Influencer Verification"
                                                                : "Individual Verification"
                                                        : "Get Verified on Pipaan"}
                                                </h2>
                                                <p className="text-sm text-[#747474]">(If Business + 10K followers)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img
                                    src={paymentError ? paymentfailed : paymentsuccess}
                                    className="w-24 h-24 mb-4"
                                    alt="Status"
                                />
                                <h2 className="text-2xl font-bold text-black my-5">
                                    {paymentError
                                        ? "Your verification request could not be processed."
                                        : "Your verification request has been submitted."}
                                </h2><div className="my-5">
                                    <p className="text-[#474747] text-[14px] font-medium max-w-md">
                                        Total Payment
                                    </p>
                                    <h3 className="text-[#121212] text-4xl max-w-md font-semibold">$80</h3>
                                    <p className="text-[#121212] text-[13px] font-[500] max-w-md">25 Feb 2023, 13:22</p>
                                </div>
                                <div class="mx-auto my-5 p-4">
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div class="border border-[#EDEDED] rounded-xl p-5 bg-white text-left min-w-lg">
                                            <p class="text-[12px] text-[#707070] mb-1">Order No</p>
                                            <p class="text-[13px] font-[400] text-[#121212] text-left">125686246</p>
                                        </div>

                                        <div class="border border-[#EDEDED] rounded-xl p-5 bg-white text-left min-w-lg">
                                            <p class="text-[12px] text-[#707070] mb-1">Payment Ref No.</p>
                                            <p className={`text-[13px] font-[400] text-left ${paymentError ? "text-red-600 font-bold" : "text-[#121212]"}`}>
                                                {paymentError ? "Payment Failed" : "123586954"}
                                            </p>
                                        </div>

                                        <div class="border border-[#EDEDED] rounded-xl p-5 bg-white text-left min-w-lg">
                                            <p class="text-[12px] text-[#707070] mb-1">Sender Name</p>
                                            <p class="text-[13px] font-[400] text-[#121212] ">Antonio Roberto</p>
                                        </div>

                                        <div class="border border-[#EDEDED] rounded-xl p-5 bg-white text-left min-w-lg">
                                            <p class="text-[12px] text-[#707070] mb-1">Payment Method</p>
                                            <p class="text-[13px] font-[400] text-[#121212] text-left">
                                                Credit Card (**** 4532)
                                            </p>
                                        </div>

                                    </div>
                                </div>
                                <button
                                    onClick={paymentError ? () => setIsPaymentSuccess(false) : handleClose}
                                    className={`text-white px-12 py-3 rounded-full font-semibold transition-colors ${paymentError ? "bg-red-600 hover:bg-red-700" : "bg-[#095228] hover:bg-[#07401f]"
                                        }`}
                                >
                                    {/* Icon only appears on payment failure */}
                                    {paymentError && (
                                        <img
                                            src={Retryicon}
                                            alt="RetryIcon"
                                            className="w-5 h-5 mr-2"
                                        />
                                    )}
                                    {paymentError ? "Retry Payment" : "View Verification Status"}
                                </button>
                            </div>
                        </div>
                    ) : (
                        /* MAIN CONTENT */
                        <>
                            <h2 className="text-[#000000] text-[32px] font-semibold">
                                {isFormView ? "Verification Details" : "Get Verified on Pipaan"}
                            </h2>

                            <hr className="bg-[#D9D9D9]" />

                            <div className="border-t-[#D9D9D9] border-t-2">
                                <div className="relative w-full max-w-4xl m-auto">

                                    {/* PROFILE */}
                                    <div className="mt-10 flex items-center w-full justify-between">
                                        <div className="flex items-start relative left-5">
                                            <div className="profile-dashboard profile-page-dashboard-modal overflow-hidden relative">
                                                <img
                                                    src={userData?.profile_picture_url || profileimg}
                                                    alt="Profile"
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>

                                            <div className="feed-title pl-4 flex flex-col">
                                                <p className="font-semibold text-[20px]">
                                                    {userData?.first_name} {userData?.last_name || "N/A"}
                                                </p>
                                                <p className="text-sm text-[#747474]">
                                                    @{userData?.username || "N/A"}
                                                </p>
                                                <p className="text-sm text-[#095228] font-semibold">
                                                    {userData?.followersCount || 0} Followers
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <img
                                                src={
                                                    isBusinessAccount ? businessbadge :
                                                        isInfluencerAccount ? influencerbadge :
                                                            Individualbadge
                                                }
                                                className="w-8 h-8"
                                                alt="badge"
                                            />
                                            <div className="flex flex-col">
                                                <h2 className="text-md font-semibold">
                                                    {isFormView
                                                        ? isBusinessAccount ? "Business Verification"
                                                            : isInfluencerAccount ? "Influencer Verification"
                                                                : "Individual Verification"
                                                        : "Get Verified on Pipaan"}
                                                </h2>
                                                <p className="text-sm text-[#747474]">(If Business + 10K followers)</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-10 animate-fadeIn">
                                        <h2 className="text-[#000000] text-[20px] font-semibold mb-4">
                                            {isFormView ? "Verification Details" : "Business Verification"}
                                        </h2>

                                        <div className="w-full m-auto">
                                            {!isFormView ? (
                                                <div className="flex flex-col items-start">
                                                    <button
                                                        onClick={() => hasMinFollowers && setIsFormView(true)}
                                                        className={`w-[350px] text-white text-md py-4 px-6 rounded-full flex items-center justify-between ${hasMinFollowers ? "bg-[#095228]" : "bg-gray-400"
                                                            }`}
                                                    >
                                                        Apply for Verification
                                                        <img src={verifyarrow} className="w-6 h-6" alt="arrow" />
                                                    </button>
                                                </div>
                                            ) : (
                                                <form className="space-y-6">
                                                    {/* PAYMENT SECTION */}
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
                                                        {/* SAVED CARDS */}
                                                        <div className="bg-[#F4F4F4] rounded-xl p-6">
                                                            <h3 className="font-semibold mb-4">Saved Cards</h3>
                                                            {cards.map((card) => (
                                                                <div
                                                                    key={card.id}
                                                                    onClick={() => setSelectedCard(card.id)}
                                                                    className={`rounded-xl p-4 flex gap-4 mb-4 cursor-pointer border-2 transition-all ${selectedCard === card.id ? "border-blue-600 bg-blue-50" : "border-transparent bg-white"}`}
                                                                >
                                                                    <div className="rounded-md overflow-hidden">
                                                                        <img src={card.img} alt={card.name} className="w-14 h-10 object-cover" />
                                                                    </div>
                                                                    <div>
                                                                        <p className="font-[400] text-md">
                                                                            <span className="text-[#27272E]">{card.name}</span>: <span className="text-[#27272E]">{card.last4}</span>
                                                                        </p>
                                                                        <p className="text-md ">
                                                                            <span className="text-[#425466]">Exp. date:</span> <span className="text-[#1A202C] text-[14px] font-medium">{card.expiry}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            <button type="button" className="w-full mt-6 bg-[#095228] text-white py-3 rounded-full">
                                                                Add New Card
                                                            </button>
                                                        </div>

                                                        {/* ORDER SUMMARY */}
                                                        <div className="bg-white border rounded-xl p-6">
                                                            <h3 className="font-bold text-xl mb-6 text-[#000000]">Order Summary</h3>
                                                            <div className="flex justify-between mb-4">
                                                                <p className="text-[#888888] text-[20px]">Subtotal</p>
                                                                <p className="text-[#000000] font-[600] text-[20px]">$565</p>
                                                            </div>
                                                            <div className="flex justify-between mb-4">
                                                                <p className="text-[#888888] text-[20px]">Tax</p>
                                                                <p className="text-[#000000] font-[600] text-[20px]">$15</p>
                                                            </div>
                                                            <hr className="my-4" />
                                                            <div className="flex justify-between mb-6 font-semibold">
                                                                <p className="text-[#000000] text-[20px] font-[400]">Total</p>
                                                                <p className="text-[#000000] text-[24px] font-[600]">$467</p>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => setIsPaymentSuccess(true)}
                                                                className="w-full bg-[#095228] text-[#FFFFFF] py-4 rounded-full"
                                                            >
                                                                Pay Now →
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <p className="text-[16px] font-semibold text-right mt-4 text-[#000000]">
                                                        Verification is valid for 1 year. Annual re-verification required.
                                                    </p>

                                                    <button
                                                        type="button"
                                                        onClick={() => setIsFormView(false)}
                                                        className="text-gray-500 text-sm"
                                                    >
                                                        Go Back
                                                    </button>
                                                </form>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Renewverifyaccount;